// src/pages/HistoryPhilosophy.jsx
import React from "react";
import { Box, Container, Typography } from "@mui/material";

/* ------------ language data ------------ */

const PHILOSOPHY_TEXT = {
  ZH: {
    title: "企業理念",
    subtitle: "自然與生活的和諧共處：潔淨、健康、環境的美好生活",
    body: [
      "我們提供深受顧客喜愛和信賴的產品和服務，並為守護人類生活做出貢獻。",
      "台灣水禾以「潔淨初心  守護健康」的核心理念",
      "致力於為社會大眾、產業夥伴提供專業可靠的衛生防護與清潔病媒防治方案。",
      "我們相信，健康不僅是個人資產，更是社會與環境的共同責任，",
      "因此積極推動兼具創新、專業與永續的產品與服務。",
    ],
  },

  EN: {
    title: "Corporate Philosophy",
    subtitle:
      "Harmony with nature through cleanliness, health, and care for our environment.",
    body: [
      "Our goal is to offer trusted products and services that protect and improve everyday life.",
      "Rooted in the belief “Cleanliness & Health Protection,” Taiwan SEHO delivers",
      "professional and dependable hygiene and vector-control solutions.",
      "We view health as a shared Responsibility and pursue Innovation, Quality, and Sustainability in everything we do.",
    ],
  },

  JP: {
    title: "企業理念",
    subtitle: "自然と生活の調和 : 清潔・健康・環境が創り、より良い暮らしそして美しい未来へ。",
    body: [
      "当社は、お客様に愛され、信頼される製品とサービスを提供し、人々の暮らしを守ることに貢献しています。",
      "台湾水禾は「ピュアな心、健康を守る」というコアスピリットのもと、社会の皆さまや産業パートナーに対して、専門性と信頼性を備えた衛生防護および清掃・防疫ソリューションを提供しています。",
      "健康は個人の資産であるだけでなく、社会と環境が共に担う責任であると私たちは考えています。",
      "そのため、イノベーション、専門性、そして持続可能性を兼ね備えた製品・サービスの展開に積極的に取り組んでいます。",
    ],
  },
};

export function getPhilosophyText(lang = "ZH") {
  return PHILOSOPHY_TEXT[lang] || PHILOSOPHY_TEXT.ZH;
}

export default function HistoryPhilosophy({
  mode = "b2b",
  fonts,
  bg = "background.default",
  rail,
  lang = "ZH", // <- ZH / EN / JP
}) {
  const accent = rail;

  // Replace with your actual deployed path
  const heroImage = "/img/aboutus/history/philosophy.webp";

  const { title, subtitle, body } = getPhilosophyText(lang);

  return (
    <Box sx={{ py: { xs: 6, md: 8 }, bgcolor: bg }}>
      <Container
        maxWidth={false}
        disableGutters
        sx={{ maxWidth: 1200, px: { xs: 2, md: 3 }, mx: "auto" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "stretch",
            bgcolor: "background.paper",
            px: { xs: 2, md: 4 },
            py: { xs: 4, md: 6 },
          }}
        >
          {/* LEFT SIDE — IMAGE */}
          <Box
            sx={{
              flex: { xs: "0 0 auto", md: "0 0 30%" },
              minHeight: { xs: 220, md: 300 },
              backgroundImage: `url(${heroImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center left",
              borderRadius: { xs: 1, md: 1 },
              mb: { xs: 3, md: 0 },
            }}
          />

          {/* RIGHT SIDE — TEXT */}
          <Box
            sx={{
              flex: { xs: "0 0 auto", md: "0 0 70%" },
              pl: { xs: 0, md: 4 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: { xs: "left", md: "left" },
            }}
          >
            <Typography
              sx={{
                fontFamily: fonts,
                fontWeight: 700,
                fontSize: { xs: 22, md: 26 },
                mb: 3,
                color: accent,
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontFamily: fonts,
                fontSize: { xs: 18, md: 22 },
                mb: 2,
              }}
            >
              {subtitle}
            </Typography>

            <Typography
              sx={{
                fontFamily: fonts,
                fontSize: { xs: 13, md: 16 },
                lineHeight: 2,
              }}
            >
              {body.map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  {idx < body.length - 1 && <br />}
                </React.Fragment>
              ))}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
